import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { BatchDialog } from 'src/modules/supply_chain/components/BatchDialog'
import { skuit } from 'src/services/skuit'

import { BatchListTable } from 'src/components/Table/list/Batch'
import { ListPage } from 'src/components/Pages/ListPage'

export const BatchListPage = () => {
  const paginator = useQueryPaginator('batch-list', skuit.sc.batches.list)

  return (
    <ListPage
      title='Batches'
      paginator={paginator}
      dialogs={[{ title: 'New Batch', Dialog: BatchDialog }]}
    >
      <BatchListTable
        paginator={paginator}
        fields={['batchType', 'client', 'clientId', 'expiresOn', 'asn']}
      />
    </ListPage>
  )
}
